import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'
import { useInView } from 'react-intersection-observer'
import { useStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

const useLocalStyles = makeStyles(theme => ({
  heightRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(2.5),
    },
  },
}))

const PhysicalInformation = () => {
  const classes = useStyles()
  const localClasses = useLocalStyles()
  const { register, errors } = useFormContext()
  const physicalErrors = errors?.physicalInformation ?? {}
  const { ref: limitationsRef, inView: limitationsInView } = useInView({
    triggerOnce: true,
  })

  useEffect(() => {
    if (limitationsInView) {
      // Rerender multiline field once in view so rows expand correctly.
    }
  }, [limitationsInView])

  return (
    <Box>
      <Typography className={classes.fieldHelper}>
        The following questions are intended to help your coaches develop
        appropriate instruction and avoid creating or aggravating player
        injuries.
      </Typography>
      <Box className={classes.fieldGroup}>
        <Box className={localClasses.heightRow}>
          <TextField
            name="physicalInformation.heightFeet"
            inputRef={register}
            type="number"
            error={!!physicalErrors?.heightFeet}
            helperText={physicalErrors?.heightFeet?.message}
            label="Height (ft)"
            variant="outlined"
            fullWidth
            id="heightFeet"
            className={classes.fieldInput}
            onInput={e => {
              e.target.value = Math.max(3, parseInt(e.target.value, 10))
                .toString()
                .slice(0, 1)
              e.target.value = Math.min(8, parseInt(e.target.value, 10))
                .toString()
                .slice(0, 1)
            }}
          />
          <TextField
            type="number"
            name="physicalInformation.heightInches"
            inputRef={register}
            error={!!physicalErrors?.heightInches}
            helperText={physicalErrors?.heightInches?.message}
            label="Height (in)"
            variant="outlined"
            fullWidth
            id="heightInches"
            className={classes.fieldInput}
            onInput={e => {
              e.target.value = Math.max(0, parseInt(e.target.value, 10))
                .toString()
                .slice(0, 2)
              e.target.value = Math.min(11, parseInt(e.target.value, 10))
                .toString()
                .slice(0, 2)
            }}
          />
        </Box>
      </Box>
      <Box className={classes.fieldGroup} ref={limitationsRef}>
        <Typography className={classes.fieldHelper}>
          Please list any physical limitations or concerns
        </Typography>
        <TextField
          name="physicalInformation.limitations"
          inputRef={register}
          multiline
          minRows={4}
          id="limitations"
          error={!!physicalErrors?.limitations}
          helperText={physicalErrors?.limitations?.message}
          placeholder="e.g., past injuries, lingering injuries, joint replacements, range of motion deficiencies (optional)"
          variant="outlined"
          fullWidth
          className={classes.fieldInput}
        />
      </Box>
    </Box>
  )
}

export default PhysicalInformation
